import { Tooltip } from '@material-ui/core';
import { createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import ModificationRequestApprovableIcon from './ModificationRequestApprovableIcon';

const ModificationRequestApprovableIconWithTooltip = () => (
  <FormattedMessage id="modification_request_state.approval">
    {(text: string) => (
      <Tooltip placement="top" title={text}>
        <div>
          <ModificationRequestApprovableIcon size={24} />
        </div>
      </Tooltip>
    )}
  </FormattedMessage>
);

export default ModificationRequestApprovableIconWithTooltip;
